import React from 'react'
import { reportDate } from './CustomUtils.js'

export default function ReportHeading(props) {
  console.log('ReportHeading rendered: ', props)

  const { title, parameterValues, showReportDate = true, widths = ['33%', '33%', '33%']} = props
  let reportDateComponent = <React.Fragment>
    <span style={{ fontWeight: 'bold'}}>Date of Report: </span><span>{reportDate()}</span>
  </React.Fragment>
  if (!showReportDate) {
    reportDateComponent = ''
  }
  return (
    <thead>
      <tr>
        <td colSpan={50}>
          <table style={{width: '100%'}}>
            <tbody>
              <tr>
                <td style={{width: widths[0], padding: '.25rem', fontWeight: 'normal', textAlign: 'left', verticalAlign: 'top', border: 'none', whiteSpace: 'nowrap'}}>{parameterValues}</td>
                <td style={{width: widths[1], padding: '.1rem', fontSize: 'large', textAlign: 'center', verticalAlign: 'top'}} className="case-table-header">{title}</td>
                <td style={{width: widths[2], padding: '.25rem', fontWeight: 'normal', textAlign: 'right', verticalAlign: 'top', border: 'none'}}>{reportDateComponent}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </thead >
  )
}
